import styled from 'styled-components'

export const MainWrapper = styled.div`
  padding: 12px;
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: flex-start;
`

export const ScrollWrapper = styled.div`
  overflow-y: scroll;
`

export const ModalHead = styled.div`
  padding: 28px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-content: center;
`

export const ModalFooter = styled.div`
  margin-top: auto;
  padding: 0px 24px 24px 24px;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: flex-end;
  align-content: center;
  align-self: flex-end;
`

export const LevelRowContainer = styled.div.attrs({
  className: `row col-12 mx-0`
})`
  border-top: 1px solid ${({ theme }) => theme.mocaLtGrey};
  padding: 24px 12px;
`
export const InputRow = styled.div`
  flex: 7;
  display: flex;
  flex-direction: column;
`

export const CheckboxWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: row;
  font-size: 12px;
  margin-top: 14px;
  opacity: ${({ allowEdit }) => (allowEdit ? 1 : 0.5)}
`

export const PickHover = styled.div`
  position:absolute;
  left: 12px;
  top: 24px;
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.getRGBA(theme.blackAbs, 0.7)};
  opacity: 0;
  transition: .3s;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  align-items: center;
`

export const ImgPicker = styled.img`
  width: 120px;
  height: 120px;
  border-radius: 50%;
  object-fit: cover;
`

export const PickWrapper = styled.div`
  flex: 3;

  &:hover ${PickHover} {
    opacity: 1;
    /* transform: translateY(-120px); */
  }
`

export const BaseDatePickerInput = styled.div`
  border-radius: 6px;
  font-size: 14px;
  height: 34px;
  border: 1px solid ${({ theme }) => theme.mocaGrey};
  background: ${({ theme }) => theme.white};
  padding: 6px 12px;
  width: 100%;
`

export const Input = styled.input`
  border-radius: 6px;
  display: block;
  font-size: 14px;
  height: 34px;
  border: 1px solid ${({ theme }) => theme.mocaGrey};
  background: ${({ theme }) => theme.white};
  padding: 6px 12px;
  width: 100%;
`
